import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useContextValues } from "../context/RouteDataContext.jsx";

export default function RouteAttributeControls({ targetRef }) {
  const navigate = useNavigate();
  const {
    routeId,
    routeShortName,
    directionId,
    setDirectionId,
    selectedDate,
    setSelectedDate,
    today,
  } = useContextValues();
  const routeIdRef = useRef(routeId);
  const routeShortNameRef = useRef(routeShortName);
  const directionIdRef = useRef(directionId);
  const selectedDateRef = useRef(selectedDate);

  routeIdRef.current = routeId;
  routeShortNameRef.current = routeShortName;
  directionIdRef.current = directionId;
  selectedDateRef.current = selectedDate;

  useEffect(() => {
    const target = targetRef.current;

    if (!target) return;

    // Let synthetic monitors drive route controls through stable DOM attributes.
    const observer = new MutationObserver((mutations) => {
      const changedAttributes = new Set(
        mutations.map(({ attributeName }) => attributeName)
      );

      if (changedAttributes.has("data-route")) {
        const nextRoute = target.dataset.route?.trim();
        const currentRouteId = String(routeIdRef.current);
        const currentRouteShortName = String(routeShortNameRef.current);

        if (
          nextRoute &&
          nextRoute !== currentRouteId &&
          nextRoute.toUpperCase() !== currentRouteShortName.toUpperCase()
        ) {
          navigate(`/plan-your-trip/routes/${encodeURIComponent(nextRoute)}`);
        }
      }

      if (changedAttributes.has("data-direction")) {
        const nextDirection = target.dataset.direction?.trim();

        if (
          nextDirection !== undefined &&
          nextDirection !== "" &&
          nextDirection !== String(directionIdRef.current)
        ) {
          setDirectionId(nextDirection);
        }
      }

      if (changedAttributes.has("data-date")) {
        const nextDate = target.dataset.date?.trim() || today;

        if (nextDate !== selectedDateRef.current) {
          setSelectedDate(nextDate);
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["data-route", "data-direction", "data-date"],
    });

    return () => observer.disconnect();
  }, [navigate, setDirectionId, setSelectedDate, targetRef, today]);

  return null;
}
